const unitMap = [
  ['Bytes', 'b'],
  'kB',
  'MB',
  'GB',
  'TB',
  'PB',
  'EB',
  'ZB',
  'YB',
];

type Options = {
  fromUnit: string;
  toUnit?: string;
};

/**
 * Find the index of a unit in the unitMap
 *
 * @param unit - The unit to find
 * @returns The index of the unit in the unitMap
 */
const findUnitIndex = (unit: string) =>
  unitMap.findIndex(u => (Array.isArray(u) ? u.includes(unit) : u === unit));

/**
 * Convert a value from one unit to another
 *
 * @param value - The value to convert
 * @param lng - The language for translation (not used in this function)
 * @param fromUnit - The unit to convert from
 * @param toUnit - The unit to convert to
 */
export const convertUnit = (
  value: number,
  _lng: string | undefined,
  { fromUnit, toUnit }: Options,
): string => {
  const fromIndex = findUnitIndex(fromUnit);
  if (fromIndex === -1) {
    throw new Error(`Invalid fromUnit: ${fromUnit}`);
  }

  let currentValue = value;
  let currentIndex = fromIndex;

  if (toUnit) {
    const toIndex = findUnitIndex(toUnit);
    if (toIndex === -1) {
      throw new Error(`Invalid toUnit: ${toUnit}`);
    }
    const diff = toIndex - fromIndex;
    currentValue *= 1024 ** diff;
    return `${currentValue} ${
      Array.isArray(unitMap[toIndex]) ? unitMap[toIndex][0] : unitMap[toIndex]
    }`;
  }

  while (currentValue >= 1024 && currentIndex < unitMap.length - 1) {
    currentValue /= 1024;
    currentIndex += 1;
  }

  const unit = Array.isArray(unitMap[currentIndex])
    ? unitMap[currentIndex][0]
    : unitMap[currentIndex];
  return `${currentValue} ${unit}`;
};
